import { Node, mergeAttributes } from "@tiptap/core";
import { communityMemberProfilePath } from "@/react/helpers/urlHelpers";
import { mentionsNodeConfiguration as originalMentionsNodeConfiguration } from "@circle-react-uikit/TipTap/Extensions/CustomExtensions/Mentions";

export const MentionsExtension = Node.create<{
  sgIdToObjectMap: Record<string, unknown>;
  onLocalSgidToObjectMapChange: ({
    sgid,
    object,
  }: {
    sgid: string;
    object: unknown;
  }) => void;
  isPreviewMode?: boolean;
}>({
  ...originalMentionsNodeConfiguration,
  parseHTML: () => [{ tag: "a" }],
  renderHTML: function ({ HTMLAttributes }) {
    const {
      options: { sgIdToObjectMap, isPreviewMode },
    } = this;
    const appliedSgid = HTMLAttributes["data-sgid"] as string;
    const object = sgIdToObjectMap?.[appliedSgid];

    if (!object) return ["span"];

    const { public_uid, name } = object as {
      public_uid: string;
      name: string;
    };

    const href = new URL(
      communityMemberProfilePath({ public_uid }),
      window.location.origin,
    ).toString();

    return [
      "a",
      mergeAttributes(HTMLAttributes, {
        href,
        target: "_blank",
        onclick: isPreviewMode ? "event.preventDefault();" : undefined,
      }),
      name,
    ];
  },
});
